import BaseModel from '../core/BaseModel'
//import UserModel from '@/models/UserModel'
export default class VehicleCategoryModel extends BaseModel {

    constructor() {
        super({
                name: "vehicle_category",
                tableName: 'vehicle_category',
                label: "Vehicle categories",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Name',
                    width: 20,
                    class: 'left',
                    filter: {type: 'input', match: 'contains'},
                },
                bond_fee: {
                    name: 'bond_fee',
                    type: "Number",
                    label: 'Bond fee',
                    width: 10,
                    class: 'left',
                },
                /*active: {
                    name: "active",
                    label: "Hiển thị",
                    type: "Checkbox"
                },*/

                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class: 'left center-active',
                    width : 8,
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    // filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_at : {
                    name: 'updated_at',
                    type: "String",
                    label: 'Updated date',
                    width: 15,
                    // filter: { type: 'DateRange', match: 'contains'},
                    class:"left",
                },
                detail_get: {
                    refs:  ' updated_by_key { id fullname }  ',
                    display: false
                },
            })
    }

}